const URL_SCHEME_REGEX = /^[a-z][a-z0-9+.-]*:\/\//i;
const INSTAGRAM_HOST_REGEX = /^(?:https?:\/\/)?(?:www\.)?instagram\.com\//i;

export const normalizeUrl = (value) => {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (URL_SCHEME_REGEX.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  return `https://${trimmed.replace(/^\/+/, '')}`;
};

export const isValidUrl = (value) => {
  if (!value) return false;
  try {
    const url = new URL(normalizeUrl(value));
    return Boolean(url.hostname && url.hostname.includes('.'));
  } catch (err) {
    return false;
  }
};

export const formatUrlForDisplay = (value) => {
  if (!value) return '';
  try {
    const url = new URL(normalizeUrl(value));
    const path = url.pathname === '/' ? '' : url.pathname.replace(/\/$/, '');
    return `${url.hostname.replace(/^www\./, '')}${path}`;
  } catch (err) {
    return value;
  }
};

export const extractInstagramHandle = (value) => {
  if (!value) return '';
  return value
    .trim()
    .replace(INSTAGRAM_HOST_REGEX, '')
    .replace(/^@/, '')
    .replace(/\/.*$/, '')
    .replace(/\?.*$/, '');
};

export const normalizeInstagramUrl = (value) => {
  const handle = extractInstagramHandle(value);
  if (!handle) return '';
  return `https://www.instagram.com/${handle}`;
};

const digitsOnly = (value) => (value || '').toString().replace(/\D+/g, '');

export const formatPhoneForTel = (value) => {
  if (!value) return '';
  const raw = value.toString().trim();
  const digits = digitsOnly(raw);
  if (!digits) return '';
  if (raw.startsWith('+')) return `+${digits}`;
  // Brazilian numbers default to +55 when no country code is supplied.
  if (digits.length === 10 || digits.length === 11) return `+55${digits}`;
  return `+${digits}`;
};

export const formatPhoneForDisplay = (value) => {
  if (!value) return '';
  const raw = value.toString().trim();
  const digits = digitsOnly(raw);
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 13 && digits.startsWith('55')) {
    const local = digits.slice(2);
    return `+55 (${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  }
  return raw;
};
